import {createFieldRenderer} from 'forms';
import classNames from 'classnames';
import React from 'react';

/**
 * Renders a field's label as a table heading.
 *
 * The value is not rendered, ie; the factory is not used.
 */
const TableHeadingRenderer = createFieldRenderer(({
    name,
    className = '',
    error = null,
    label,
}) => <th
        className={classNames(
            className,
            'table-row-header',
            `field-renderer-${name}`,
            { 'has-error': !!error }
        )}>
    {label}
</th>);

export default TableHeadingRenderer;
